import { useState } from 'react';
import {
    Dialog,
    DialogContent,
} from '@/components/ui/dialog';

/**
 * PhotoThumbnail Component
 *
 * Displays a clickable photo thumbnail that opens in a modal dialog.
 * Reuses existing photo-upload utilities from the design system.
 *
 * Features:
 * - 64x64px thumbnail using photo-upload-image-container utility
 * - Modal dialog for fullscreen preview
 * - Fade-in transition using photo-upload-image utility
 * - Empty state with "-" when no photo URL provided
 *
 * @param url - Photo URL (optional)
 * @returns JSX element
 *
 * @example
 * <PhotoThumbnail url="https://example.com/photo.jpg" />
 */
export function PhotoThumbnail({ url }: { url?: string | null }) {
    const [isOpen, setIsOpen] = useState(false);

    if (!url) {
        /* `text-gray-400` pe alb da 2,54:1, sub pragul de 4,5 pentru text — iar la
           `text-xs` (12px) e si sub pragul de marime. E singurul semn ca poza
           lipseste, deci nu e decorativ. */
        return <span className="text-small text-muted-foreground">-</span>;
    }

    return (
        <>
            <button
                onClick={() => setIsOpen(true)}
                className="photo-upload-image-container w-16 h-16 cursor-pointer hover:opacity-80 transition-opacity"
                type="button"
            >
                <img
                    src={url}
                    alt="Thumbnail"
                    className="photo-upload-image"
                    loading="lazy"
                />
            </button>

            <Dialog open={isOpen} onOpenChange={setIsOpen}>
                <DialogContent className="max-w-4xl">
                    <img
                        src={url}
                        alt="Full preview"
                        className="w-full h-auto rounded-md"
                    />
                </DialogContent>
            </Dialog>
        </>
    );
}
